module.exports = __webpack_public_path__ + "fonts/modern-regular.dc1403f.woff";


//////////////////
// WEBPACK FOOTER
// ./src/components/posters/mockingbird/fonts/modern-regular.woff
// module id = 389
// module chunks = 0